/*
Version 0.140

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2019.

!Changelog

2020
	17-02-2020
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_language_switcher = {};

(function(){
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************

	this.onready = function() {
			
		$(document).on('click','.js-language-switcher',function(){ 
					
			/*
			Get: Language to switch to
			*/
			var _switch_to_language = '';
			if(_language == 'nl') {
				_switch_to_language = 'en';
			} else {
				_switch_to_language = 'nl';
			}

			/*
			Switch
			*/
			specific_language_switcher.switch(
				_switch_to_language
			);

		});

	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	this.switch = function(
		_language
	) {

		/*
		Get: URL
		*/
		var _switch_url_slug = '';

		// if(url[3] !== '') { 

		// 	var _page = '';

		// 	// if(_language == 'nl') { _page = 'vacatures'; }
		// 	// if(_language == 'en') { _page = 'jobs'; }

		// 	_switch_url_slug = _page + '/' + url[3];


		// } else {
			
		if(url[2] !== '') { 

			/*
			To: English
			*/
			if(_language == 'en') {
				switch(url[2]) {

					default: 
						_switch_url_slug = url[2];
					break;

					case 'informatie':
						_switch_url_slug = 'information';
					break;
						case 'waarom-kies-je-voor-mij':
							_switch_url_slug = 'why-do-you-choose-me';
						break;
						case 'wat-kunt-u-verwachten':
							_switch_url_slug = 'what-can-you-expect';
						break;
					case 'tarieven':
						_switch_url_slug = 'pricing';
					break;
					case 'contact':
						_switch_url_slug = 'contact';
					break;

					case 'algemene-voorwaarden':
						_switch_url_slug = 'terms-and-conditions';
					break;

					case 'privacy-verklaring':
						_switch_url_slug = 'privacy-statement';
					break;

					case 'voorbeeld':
						_switch_url_slug = 'example';
					break;

				}
			}

			/*
			To: Dutch
			*/
			if(_language == 'nl') {
				switch(url[2]) {

					default: 
						_switch_url_slug = url[2];
					break;

					case 'information':
						_switch_url_slug = 'informatie';
					break;
						case 'why-do-you-choose-me':
							_switch_url_slug = 'waarom-kies-je-voor-mij';
						break;
						case 'what-can-you-expect':
							_switch_url_slug = 'wat-kunt-u-verwachten';
						break;
					case 'pricing':
						_switch_url_slug = 'tarieven';
					break;
					case 'contact':
						_switch_url_slug = 'contact';
					break;

					case 'terms-and-conditions':
						_switch_url_slug = 'algemene-voorwaarden';
					break;

					case 'privacy-statement':
						_switch_url_slug = 'privacy-verklaring';
					break;

				case 'example':
						_switch_url_slug = 'voorbeeld';
					break;

				}
			}

		}

		//}

		if(_switch_url_slug == '') {
			window.location.href = globalUrl + '/' + _language;
		} else {
			window.location.href = globalUrl + '/' + _language + '/' + _switch_url_slug;
		}
		
	};

}).apply(specific_language_switcher); 